import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import PurchaseCharts from "../partials/PurchaseCharts";
import DeployedChart from "../partials/DeployedChart";
import BalanceCard from "../../../auth/wallet/BalanceCard";
import { walletType } from "../../dashboard/DashboardUtils";

const LogisticsHeader = ({ currentTab, currentFilter }) => {
	const { adminWallet } = useSelector((state) => state.wallet);
	const mainWallet = adminWallet?.find((wallet) => wallet?.product === walletType.main);

	return (
		<>
			<BalanceCard wallet={mainWallet} />
			{currentTab === "procured_assets" || currentTab === "awaiting_purchase" ? (
				<PurchaseCharts currentFilter={currentFilter} />
			) : null}
			{currentTab === "deployed_assets" ? <DeployedChart currentFilter={currentFilter} /> : null}
		</>
	);
};

LogisticsHeader.propTypes = {
	currentTab: PropTypes.string,
	currentFilter: PropTypes.string,
};

export default LogisticsHeader;
